import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiColumns, FiMap, FiGrid, FiClock, FiHome, FiMenu, FiX } from 'react-icons/fi';
import { COLORS, FONT_STACK } from '../theme';
import AgentAvatar from '../AgentAvatar';
import ContactModal from './ContactModal'; // Import the modal

export default function AppHeader({ agent, viewMode, onViewModeChange, dataMode, onDataModeChange, isMobile = false, onGoHome }) {
  const [showContactModal, setShowContactModal] = useState(false);
  // const [showMenu, setShowMenu] = useState(false); // Removed for bottom navigation

  // Define mobile header JSX
  const mobileHeader = (
    <header style={{
      background: COLORS.white,
      borderBottom: `2px solid ${COLORS.primaryRed}`,
      padding: '1rem',
      position: 'sticky',
      top: 0,
      zIndex: 1000
    }}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer' }} onClick={onGoHome}>
          <AgentAvatar name={agent.name} size={40} imageUrl={agent.headshotUrl} isMobile={isMobile} />
          <div>
            <div style={{ 
              fontFamily: FONT_STACK.join(','), 
              fontSize: '1.1rem',
              fontWeight: 600,
              lineHeight: '1.2',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '200px'
            }}>
              {agent.name}
            </div>
            <div style={{ 
              fontSize: '0.8rem', 
              color: COLORS.primaryDarkBlue,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '200px'
            }}>
              {agent.company || 'REMAX Key Properties'}
            </div>
          </div>
        </div>
        {/* Contact Button replaces hamburger menu */}
        <button
          onClick={() => setShowContactModal(true)}
          style={{
            background: COLORS.grey, // Theme light grey
            border: '1px solid #dddddd', // Subtle darker grey border
            borderRadius: '4px',
            color: COLORS.black, // Theme black
            cursor: 'pointer',
            padding: '0.5rem 0.75rem', // Adjusted padding
            fontSize: '0.9rem',
            fontWeight: 500,
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.05)', // Subtle shadow
            lineHeight: '1.2',
            textAlign: 'center'
          }}
          aria-label="Contact Agent"
        >
          Contact
        </button>
      </div>
      {/* Hamburger menu content removed as it's replaced by bottom navigation */}
    </header>
  );

  // Define desktop header JSX
  const desktopHeader = (
    <header style={{
      background: COLORS.white,
      borderBottom: `2px solid ${COLORS.primaryRed}`,
      padding: '1rem 0',
      position: 'relative',
      zIndex: 1000,
      minHeight: '80px',
      display: 'flex',
      alignItems: 'center'
    }}>
      <div style={{
        display: 'grid',
        gridTemplateColumns: '1fr auto 1fr',
        alignItems: 'center',
        gap: '2rem',
        width: '100%',
        maxWidth: 1400,
        margin: '0 auto',
        padding: '0 24px'
      }}>
        {/* Agent Info */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', justifySelf: 'start', cursor: 'pointer' }} onClick={onGoHome}>
          <AgentAvatar name={agent.name} size={48} imageUrl={agent.headshotUrl} isMobile={isMobile} />
          <div>
            <h1 style={{ fontFamily: FONT_STACK.join(','), fontSize: '2rem', margin: 0 }}>{agent.name}</h1>
            <div style={{ color: COLORS.primaryDarkBlue, fontWeight: 600 }}>REMAX Key Properties</div>
          </div>
        </div>

        {/* View Controls */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
          {/* Data Mode Toggle */}
          <div className="toggle-group" style={{ marginRight: '1rem' }}>
            <button
              className={`toggle-button ${dataMode === 'current' ? 'active' : ''}`}
              onClick={() => onDataModeChange('current')}
            >
              <FiHome /> Current
            </button>
            <button
              className={`toggle-button ${dataMode === 'historical' ? 'active' : ''}`}
              onClick={() => onDataModeChange('historical')}
            >
              <FiClock /> Past Sales
            </button>
          </div>

          {/* View Mode Toggle */}
          <div className="toggle-group">
            
            <button
              className={`toggle-button ${viewMode === 'gallery' ? 'active' : ''}`}
              onClick={() => onViewModeChange('gallery')}
            >
              <FiGrid /> Gallery
            </button>
            <button
              className={`toggle-button ${viewMode === 'map' ? 'active' : ''}`}
              onClick={() => onViewModeChange('map')}
            >
              <FiMap /> Map
            </button>
          </div>
        </div>

        {/* Agent Contact Info */}
        <div style={{ textAlign: 'right', minWidth: 180, justifySelf: 'end' }}>
          <div style={{ fontWeight: 600 }}>{agent.phone}</div>
          <div style={{ color: COLORS.primaryBlue }}>{agent.email}</div>
          <div style={{ fontSize: 14, color: '#888' }}>{agent.address}</div>
        </div>
      </div>
    </header>
  );

  return (
    <>
      <ContactModal 
        agentInfo={agent}
        show={showContactModal} 
        onClose={() => setShowContactModal(false)} 
        isMobile={isMobile} 
      />
      {isMobile ? mobileHeader : desktopHeader}
    </>
  );
}
